import * as React from 'react';
import { Link } from 'react-router-dom';
import LeftNav from 'components/LeftNav';
import { baseUrl } from 'settings/index';
import type { NavLinkProps, MobileNavLinkProps } from './NavLink.types';
import {
  NavIconWrapper,
  MobileItemName,
  MobileNavLinkContainer,
  NavItemText,
} from './NavLink.style';

const getIconState = (
  selected: boolean,
  icon?: React.ReactElement<any>,
  solidIcon?: React.ReactElement<any>,
): Record<string, any> =>
  selected
    ? {
        color: (props) => props.theme.palette.primary.hundred,
        icon: solidIcon,
      }
    : {
        color: (props) => props.theme.palette.neutral.sixty,
        icon,
      };

const MobileNavLink = ({ item, selected = false }: MobileNavLinkProps): React.ReactElement<any> => {
  const linkTo = item.path ? `${item.path}` : '';
  const iconState = getIconState(selected, item.icon, item.solidIcon);
  return (
    <MobileNavLinkContainer to={linkTo} selected={selected}>
      <NavIconWrapper color={iconState.color}>{iconState.icon}</NavIconWrapper>
      <MobileItemName>{item.name}</MobileItemName>
    </MobileNavLinkContainer>
  );
};

const NavLink = ({ item, selected }: NavLinkProps): React.ReactElement<any> => {
  const { path = '', name } = item;
  const pathname = `${path}`;
  const isSelected =
    name !== 'Home'
      ? selected.includes(pathname) && selected.indexOf(pathname) === 0
      : selected === pathname;
  const linkTo = path === 'mysearch' ? `${baseUrl}/${path}` : `${path}`;
  const iconState = getIconState(isSelected, item.icon, item.solidIcon);
  return (
    <Link to={linkTo} className='lnav-link'>
      <LeftNav.Item>
        <LeftNav.Icon>
          <NavIconWrapper color={iconState.color}>{iconState.icon}</NavIconWrapper>
        </LeftNav.Icon>
        <NavItemText selected={isSelected}>{item.name}</NavItemText>
      </LeftNav.Item>
    </Link>
  );
};

NavLink.Mobile = MobileNavLink;
export default NavLink;
